import React, { useEffect } from 'react';
import { Verification } from '@sunbit-dev/ui/src/components/card-apply/pages/verification/verification';
import { useDispatch, useSelector } from 'react-redux';
import { selectCustomerPhone, selectVerificationLink, selectInitialDetails } from '../selectors';
import { noToken } from '../actions/applicationLandingActions';
import ApplicationError from '@sunbit-dev/common/models/ApplicationError';
import { sendVerifySMS } from '../actions/verificationActions';
import { datadogRum } from '@sunbit-dev/common/services/datadog';

const sendAgainLinkCountdownSeconds = 45;

export const VerificationContainer: React.FC = () => {
  const initialDetails = useSelector(selectInitialDetails);
  const link = useSelector(selectVerificationLink);
  const customerPhoneNumber = useSelector(selectCustomerPhone);
  const dispatch = useDispatch();

  const onSendSMS = () => {
    datadogRum.addAction(`verification-sms-clicked`, {});
    dispatch(sendVerifySMS());
  };

  useEffect(() => {
    if (!initialDetails.id) {
      dispatch(noToken({ message: 'noToken', code: 'noToken' } as ApplicationError));
    } else {
      datadogRum.addAction(`verification-page-desktop`, {});
    }
  }, [initialDetails.id, dispatch, link]);

  return initialDetails.id && link ? (
    <Verification
      customerPhoneNumber={customerPhoneNumber}
      sendAgainCountDown={sendAgainLinkCountdownSeconds}
      link={link}
      onSendSMS={onSendSMS}
    />
  ) : null;
};
